import React from 'react';
import EntriesFilterRow from './ResultsTab/TableFilters/EntriesFilterRow';
import { SavedWorkTypeDefinition } from './savedWorkTaxonomy';

interface FiltersType {
  ticketTypes: SavedWorkTypeDefinition[];
  selectedOptsType: string[];
  setSelectedOptsType: any;
  selectedOptsScope: string[];
  setSelectedOptsScope: any;
  selectedOptsFreq: string[];
  setSelectedOptsFreq: any;
  selectedOptsStatus: string[];
  setSelectedOptsStatus: any;
}

const Filters: React.FC<FiltersType> = ({
  ticketTypes,
  selectedOptsType,
  setSelectedOptsType,
  selectedOptsScope,
  setSelectedOptsScope,
  selectedOptsFreq,
  setSelectedOptsFreq,
  selectedOptsStatus,
  setSelectedOptsStatus,
}) => {
  const scopeOptions = ['Shared With Me', 'Favorites'];
  const screeningFreq = [
    {
      id: 1,
      name: 'Once',
    },
    {
      id: 2,
      name: 'Daily',
    },
    {
      id: 3,
      name: 'Weekly',
    },
    {
      id: 4,
      name: 'Monthly',
    },
    {
      id: 5,
      name: 'Yearly',
    },
  ];

  const screeningStatus = [
    {
      id: 1,
      name: 'Pending',
    },
    {
      id: 2,
      name: 'Complete',
    },
    {
      id: 3,
      name: 'New Results',
    },
    {
      id: 4,
      name: 'Reviewed',
    },
    {
      id: 5,
      name: 'Approved',
    },
    {
      id: 6,
      name: 'Rejected',
    },
  ];

  return (
    <div className='full-list-filters'>
      <div className='full-list-filters-header'>Type</div>
      <div className='full-list-filters-cont'>
        {ticketTypes.map((type, index) => (
          <EntriesFilterRow
            key={index}
            name={type.label}
            value={type.key}
            selectedItems={selectedOptsType}
            setSelectedItems={setSelectedOptsType}
          />
        ))}
      </div>
      <div className='full-list-filters-header'>Scope</div>
      <div className='full-list-filters-cont'>
        {scopeOptions.map((scope, index) => (
          <EntriesFilterRow
            key={index}
            name={scope}
            selectedItems={selectedOptsScope}
            setSelectedItems={setSelectedOptsScope}
          />
        ))}
      </div>
      <div className='full-list-filters-header'>Screening Frequency</div>
      <div className='full-list-filters-cont'>
        {screeningFreq.map((row: any, index: number) => (
          <EntriesFilterRow
            key={index}
            name={row.name}
            selectedItems={selectedOptsFreq}
            setSelectedItems={setSelectedOptsFreq}
          />
        ))}
      </div>
      <div className='full-list-filters-header'>Status</div>
      <div className='full-list-filters-cont'>
        {screeningStatus.map((row: any, index: number) => (
          <EntriesFilterRow
            key={index}
            name={row.name}
            selectedItems={selectedOptsStatus}
            setSelectedItems={setSelectedOptsStatus}
          />
        ))}
      </div>
    </div>
  );
};

export default Filters;
